import {connect} from 'react-redux';

import {bindActionCreators, type Dispatch} from 'redux';

import {type GlobalState} from 'types/store';

import {type GenericAction} from 'mattermost-redux/types/actions';
import {type Post, type PostPreviewMetadata} from 'mattermost-redux/types/posts';

import {makeGetChannel} from 'mattermost-redux/selectors/entities/channels';
import {get} from 'mattermost-redux/selectors/entities/preferences';
import {getCurrentRelativeTeamUrl} from 'mattermost-redux/selectors/entities/teams';
import {getUser} from 'mattermost-redux/selectors/entities/users';
import {getPost} from 'mattermost-redux/selectors/entities/posts';

import {isEmbedVisible} from 'selectors/posts';

import {toggleEmbedVisibility} from 'actions/post_actions';

import {Preferences} from 'utils/constants';

import {General} from 'mattermost-redux/constants';

import {getDisplayNameByUser} from 'utils/utils';

import {getPostOverrideUsername} from 'features/posts/selectors/get_post_override_username';
import {getPostOverrideIconURL} from 'features/posts/selectors/get_post_override_icon_url';

import PostMessagePreview from './post_message_preview';

type Props = {
    metadata: PostPreviewMetadata;
    previewPost?: Post;
}

function makeMapStateToProps() {
    const getChannel = makeGetChannel();

    return (state: GlobalState, ownProps: Props) => {
        const currentTeamUrl = getCurrentRelativeTeamUrl(state);

        let user;
        let userDisplayName;
        let embedVisible = false;
        let channelDisplayName = ownProps.metadata.channel_display_name;
        const previewPost = getPost(state, ownProps.metadata.post_id) || ownProps.previewPost;

        if (previewPost && previewPost.user_id) {
            user = getUser(state, previewPost.user_id);
            userDisplayName = getDisplayNameByUser(state, user);
        }
        if (previewPost && previewPost.id) {
            embedVisible = isEmbedVisible(state, previewPost.id);
        }

        if (ownProps.metadata.channel_type === General.DM_CHANNEL) {
            channelDisplayName = getChannel(state, {id: ownProps.metadata.channel_id})?.display_name ?? '';
        }

        return {
            currentTeamUrl,
            channelDisplayName,
            overrideUsername: getPostOverrideUsername(state, previewPost),
            overrideIconURL: getPostOverrideIconURL(state, previewPost),
            previewPost,
            user,
            userDisplayName,
            isEmbedVisible: embedVisible,
            compactDisplay: get(state, Preferences.CATEGORY_DISPLAY_SETTINGS, Preferences.MESSAGE_DISPLAY, Preferences.MESSAGE_DISPLAY_DEFAULT) === Preferences.MESSAGE_DISPLAY_COMPACT,
        };
    };
}

function mapDispatchToProps(dispatch: Dispatch<GenericAction>) {
    return {
        actions: bindActionCreators({toggleEmbedVisibility}, dispatch),
    };
}

export default connect(makeMapStateToProps, mapDispatchToProps)(PostMessagePreview);
